import { Button, Modal, Select, Table } from "antd";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory, useLocation } from "react-router-dom";
import CommonLoader from "./Loaders/loader";
import {
  fetchWeldParametersRequest,
  fetchWeldParametersSuccess,
  updateRenamePasses,
} from "../redux/data360Live_WeldParameter/action";

const { Option } = Select;

const passNameOptions = [
  "Hot",
  "Root",
  "Fill",
  "Last Fill",
  "Strip",
  "Cap",
  "Weave",
  "Disabled",
];

const newPassNumbers = ["Clear"];
for (let i = 1; i <= 20; i++) {
  newPassNumbers.push(i);
}

const RenamingPassTable = () => {
  const location = useLocation();
  const history = useHistory();
  const { jobNumber, machineType } = location.state;
  const [data, setData] = useState([]);
  const [renamePassData, setRenamePassData] = useState([]);
  const [warningVisible, setWarningVisible] = useState(false);
  const [cancelAlertVisible, setCancelAlertVisible] = useState(false);
  const [selectedPassNames, setSelectedPassNames] = useState({});
  const [selectedPassNumbers, setSelectedPassNumbers] = useState({});
  // const [downloadingVisible, setDownloadingVisible] = useState(false);
  // const [progress, setProgress] = useState(0);
  const [passNameValidationErrors, setPassNameValidationErrors] = useState({});

  const dispatch = useDispatch();
  const currentProject = useSelector(
    (state) => state?.data360LiveProjectReducer?.currentProject
  );
  const weldParameters = useSelector(
    (state) => state?.data360LiveWeldParameterReducer?.data
  );
  const loading = useSelector(
    (state) => state?.data360LiveWeldParameterReducer?.loading
  );

  const handleChange = (key, field, value) => {
    setData((prev) => {
      const newData = prev.map((row) =>
        row.key == key ? { ...row, [field]: value } : row
      );
      return newData;
    });
    const [currentRow] = data?.filter((ite) => ite.key == key);
    if (field === "newPassName") {
      setSelectedPassNames((prevState) => ({
        ...prevState,
        [`${currentRow?.groupNo}-${currentRow?.torch}`]: value,
      }));
    } else if (field == "numberToAppend") {
      setSelectedPassNumbers((prevState) => ({
        ...prevState,
        [`${currentRow?.groupNo}-${currentRow?.torch}`]: value,
      }));
    }
  };

  const projectId = currentProject?.project_id;
  const { groupedByMachine } = weldParameters;

  let jsonData = null;

  for (const machine in groupedByMachine) {
    const found = groupedByMachine?.[machine]?.find(
      (obj) => obj.job_number === jobNumber
    );
    if (found) {
      jsonData = found?.parsed_json_data;
      break;
    }
  }

  const extractRequiredPassValues = (weldValues) => {
    if (!weldValues || typeof weldValues !== "object") {
      throw new Error("weldValues is undefined or not an object");
    }
    const getValueByKey = (arr, key) => {
      const item = arr?.find((obj) => Object.keys(obj)[0] === key)?.[key];
      return item;
    };
    const passData = weldValues?.["Pass"];

    const allKeys = {
      "Pass Name": true,
      "Pass Group Number": true,
      "Pass Pendant Name": true,
      "Power Supply": true,
      "Zone Enable": false,
    };

    const passValues = {};

    for (const [key, isRequired] of Object.entries(allKeys)) {
      let value = getValueByKey(passData, key);

      if (!value) {
        for (const section of Object.values(weldValues)) {
          value = getValueByKey(section, key);
          if (value) break;
        }
      }

      if (isRequired && !value)
        throw new Error(`Missing value for key: ${key}`);
      if (value) passValues[key] = value;
    }
    return passValues;
  };

  const processP625JsonToRenameScreen = () => {
    const header = jsonData?.["WELD PARAMETERS"]?.header;
    const values = jsonData?.["WELD PARAMETERS"]?.values;
    const passValues = extractRequiredPassValues(values);

    const passNames = passValues?.["Pass Name"];
    const passGrpNumbers = passValues?.["Pass Group Number"];
    const pendantNames = passValues?.["Pass Pendant Name"];
    const zoneEnabled = passValues?.["Zone Enable"];
    for (let i = 0; i <= zoneEnabled?.length; i++) {
      if (zoneEnabled[i] == "Disabled") {
        passNames[i] = "Disabled";
      }
    }
    let index = 0;
    let tempRenamePassData = [];
    header.forEach((item) => {
      let torches = Object.values(item)[0];
      torches.forEach((torch) => {
        let obj = {};
        obj.groupNumber = passGrpNumbers[index];
        obj.torch = torch;
        obj.passName = `${passNames[index]} (${pendantNames[index]})`;
        index++;
        tempRenamePassData.push(obj);
      });
    });
    setRenamePassData(tempRenamePassData);
  };

  const handleUnusedPassName = () => {
    for (const JSONobj of jsonData) {
      if (JSONobj.Type === "PASS" && JSONobj.PassEnable === "No") {
        JSONobj.PassName = "Disabled";
      }
    }
    return jsonData;
  };

  const processP600ZJsonToRenameScreen = () => {
    const weldJSONFile = handleUnusedPassName();

    for (const JSONobj of weldJSONFile) {
      if (JSONobj.Type === "PASS") {
        let obj = {};
        obj.groupNumber = JSONobj.PassGroupNumber;
        obj.torch = JSONobj.Torch;
        obj.passName = `${JSONobj.PassName} (${JSONobj.PassPendName})`;
        renamePassData.push(obj);
      }
    }
    setRenamePassData(renamePassData);
  };

  const getPipeParameters = (jsonData) => {
    /* output format
      [
        { displayName: '30_FullPulse_688', groupName: 'D', pipeNumber: 1 },
        { displayName: '30_STT_Pulse_688', groupName: 'E', pipeNumber: 2 }
      ]
    */
    const finalPipeData = [];
    const keys = Object.keys(jsonData).filter(
      (key) => typeof key === "string" && key.startsWith("PIPE PARAMETERS;")
    );

    keys?.forEach((key, index) => {
      finalPipeData.push({
        displayName: jsonData[key]?.displayName,
        groupName: jsonData[key]?.groupName,
        pipeNumber: index,
      });
    });

    return finalPipeData;
  };

  const getPipeNameAttached = (displayName) => {
    return `PIPE PARAMETERS;${displayName}`;
  };

  const processM500JsonToRenameScreen = () => {
    let renamePassData = [];

    const pipeItems = getPipeParameters(jsonData);

    pipeItems.map((pipeItem) => {
      const headers =
        jsonData[getPipeNameAttached(pipeItem?.displayName)]?.headers;

      Object.keys(headers).forEach((key) => {
        const groupId = key;
        const zones = headers[key]?.zones;
        Object.values(zones).forEach((zone) => {
          let obj = {};
          obj.groupNumber = groupId;
          obj.torch = pipeItem?.displayName;
          obj.passName = `${headers[key]?.name} (${zone?.name})`;
          renamePassData.push(obj);
        });
      });
    });

    setRenamePassData(renamePassData);
  };

  useEffect(() => {
    dispatch(
      fetchWeldParametersRequest({
        project_id: projectId,
      })
    );
  }, []);

  useEffect(() => {
    if (machineType?.toLowerCase() === "p625" && jsonData) {
      processP625JsonToRenameScreen();
    }
    if (machineType?.toLowerCase() === "p600z" && jsonData) {
      processP600ZJsonToRenameScreen();
    }
    if (machineType?.toLowerCase() === "m500" && jsonData) {
      processM500JsonToRenameScreen();
    }
  }, [machineType, jsonData]);

  // Function to map backend data to table data
  function mapRenamePassDataToTableData(renamePassData) {
    // Group by groupNumber and torch
    const grouped = {};
    renamePassData.forEach((item) => {
      const key = `${item.groupNumber}-${item.torch}`;
      if (!grouped[key]) {
        grouped[key] = {
          groupNo: item.groupNumber,
          torch: item.torch,
          passNames: [],
          newPassName: "",
          numberToAppend: "",
        };
      }
      grouped[key].passNames.push(item.passName);
    });
    // Assign unique keys for table rendering
    return Object.values(grouped).map((item, idx) => ({
      ...item,
      key: (idx + 1).toString(),
    }));
  }

  // Update table data when renamePassData changes
  useEffect(() => {
    if (renamePassData && renamePassData.length > 0) {
      setData(mapRenamePassDataToTableData(renamePassData));
    }
  }, [renamePassData]);

  const columns = [
    {
      title: "Group No",
      dataIndex: "groupNo",
      key: "groupNo",
      width: 100,
      align: "center",
    },
    {
      title: "Torch",
      dataIndex: "torch",
      key: "torch",
      width: 120,
      align: "center",
    },
    {
      title: "Pass Name",
      dataIndex: "passNames",
      key: "passNames",
      width: 200,
      render: (passNames) => (
        <div>
          {passNames.map((name, idx) => (
            <div key={idx} style={{ color: "#ff4d4f", marginBottom: 2 }}>
              • {name}
            </div>
          ))}
        </div>
      ),
    },
    {
      title: "New Pass Name",
      dataIndex: "newPassName",
      key: "newPassName",
      width: 200,
      render: (value, record) => (
        <div>
          <Select
            className="rename-pass"
            placeholder="Select Pass Name"
            value={value || undefined}
            onChange={(val) => {
              handleChange(record.key, "newPassName", val);
              setPassNameValidationErrors((prev) => ({
                ...prev,
                [record.key]: false,
              }));
            }}
          >
            {passNameOptions.map((opt) => (
              <Option key={opt} value={opt}>
                {opt}
              </Option>
            ))}
          </Select>
          {passNameValidationErrors[record.key] && (
            <div style={{ color: "#ff4d4f", fontSize: 12, marginTop: 2 }}>
              Please select a pass name.
            </div>
          )}
        </div>
      ),
    },
    {
      title: "Number to Append",
      dataIndex: "numberToAppend",
      key: "numberToAppend",
      width: 180,
      render: (value, record) => (
        <Select
          className="rename-pass"
          placeholder="Select Pass Number"
          value={value || undefined}
          onChange={(val) => {
            handleChange(record.key, "numberToAppend", val);
          }}
        >
          {newPassNumbers.map((opt) => (
            <Option key={opt} value={opt}>
              {opt}
            </Option>
          ))}
        </Select>
      ),
    },
  ];

  function handleSubmit() {
    setWarningVisible(true);
  }

  function handleWarningYes() {
    setWarningVisible(false);

    // Validation: Check all select dropdowns for pass names are filled
    const missingPassNameKeys = data
      .filter(
        (row) =>
          !selectedPassNames[`${row.groupNo}-${row.torch}`] && !row.newPassName // fallback to row.newPassName if already set
      )
      .map((row) => row.key);

    if (missingPassNameKeys.length > 0) {
      // Set validation errors for missing selects
      const errors = {};
      missingPassNameKeys.forEach((key) => {
        errors[key] = true;
      });
      setPassNameValidationErrors(errors);
      return; // Do not proceed
    }
    console.log("clicked");
    setPassNameValidationErrors({}); // Clear errors if all filled

    const updatedRenamePassData = renamePassData.map((ite) => {
      const selectedPassName =
        selectedPassNames[`${ite?.groupNumber}-${ite?.torch}`];
      const selectedPassNumber =
        selectedPassNumbers[`${ite?.groupNumber}-${ite?.torch}`];

      if (selectedPassName) {
        let passNameParts = selectedPassName.split(" ");

        if (
          !isNaN(passNameParts[passNameParts.length - 1]) ||
          passNameParts[passNameParts.length - 1] === "Clear"
        ) {
          passNameParts.pop();
        }

        if (selectedPassNumber !== "Clear") {
          passNameParts.push(selectedPassNumber);
        }
        if (ite?.passName.startsWith("Disabled")) {
          ite.newPassName = "Disabled";
        } else {
          ite.newPassName = passNameParts.join(" ");
        }
      }
      return ite;
    });

    setRenamePassData(updatedRenamePassData);
    console.log(updatedRenamePassData, "dispatch this");

    dispatch(
      updateRenamePasses({
        project_id: projectId,
        job_number: jobNumber,
        is_renamed: true,
        json_payload: { renamed_passes: updatedRenamePassData },
        cb: () => {
          dispatch(fetchWeldParametersSuccess({}));
          history.push("/data360Live");
        },
      })
    );
  }

  function handleWarningNo() {
    setWarningVisible(false);
  }

  const calcHeight = -200;
  const tableHeight = `calc(${calcHeight}px + 100vh)`;
  return (
    <>
      {loading ? (
        <div className="rename-pass-loader">
          <CommonLoader />
        </div>
      ) : (
        <div
          className="welding-parameters-container"
          style={{
            height: tableHeight,
            position: "relative",
          }}
        >
          <h2 className="renaming-pass-title">Renaming pass</h2>

          {data.length > 0 ? (
            <Table
              dataSource={data}
              columns={columns}
              pagination={false}
              bordered
              size="middle"
              scroll={{ y: tableHeight }}
              className="welding-parameters-table rename-pass"
            />
          ) : (
            <div
              style={{
                color: "#fff",
                textAlign: "center",
                marginTop: 40,
                fontSize: 18,
              }}
            >
              Loading...
            </div>
          )}

          <div
            style={{
              display: "flex",
              justifyContent: "flex-end",
              marginTop: "65px",
              gap: "10px",
            }}
          >
            <Button
              size="large"
              onClick={() => setCancelAlertVisible(true)}
              style={{
                backgroundColor: "#ff4d4f",
                borderColor: "#ff4d4f",
                color: "#fff",
                borderRadius: "20px",
                paddingLeft: "30px",
                paddingRight: "30px",
              }}
            >
              Cancel
            </Button>
            <Button
              type="primary"
              size="large"
              onClick={handleSubmit}
              style={{
                backgroundColor: "#ff4d4f",
                borderColor: "#ff4d4f",
                color: "#fff",
                height: 40,
                borderRadius: "20px",
                paddingLeft: "30px",
                paddingRight: "30px",
              }}
            >
              Submit
            </Button>
          </div>
          {/* Warning Modal */}
          <Modal
            title="Warning"
            open={warningVisible}
            onCancel={handleWarningNo}
            footer={[
              <Button key="no" onClick={handleWarningNo}>
                No
              </Button>,
              <Button key="yes" type="primary" onClick={handleWarningYes}>
                Yes
              </Button>,
            ]}
            centered
            className="download-weld-parameters-modal"
          >
            Do you want to rename the passes? (Note: Passes renamed once cannot
            be changed)
          </Modal>
          <Modal
            title="Warning"
            open={cancelAlertVisible}
            footer={[
              <Button
                key="ok"
                type="secondary"
                onClick={() => setCancelAlertVisible(false)}
              >
                No
              </Button>,
              <Button
                key="ok"
                type="primary"
                onClick={() =>
                  dispatch(
                    updateRenamePasses({
                      project_id: projectId,
                      job_number: jobNumber,
                      is_renamed: true,
                      cb: () => {
                        dispatch(fetchWeldParametersSuccess({}));
                        history.push("/data360Live");
                      },
                    })
                  )
                }
              >
                Yes
              </Button>,
            ]}
            centered
            className="download-weld-parameters-modal"
          >
            Are you certain you don&apos;t want to rename the passes?
            <br />
            (Note: Original pass names will be used)
          </Modal>
        </div>
      )}
    </>
  );
};

export default RenamingPassTable;
